import { useContext } from "react";
import { LangContext, CatsFilterContext } from "./AppContext";

export default function Nav({categories, toggleCategory}){

  const {catsFilter, setCatsFilter} = useContext(CatsFilterContext);
  const {lang} = useContext(LangContext);


  return(
<nav className="flex w-full flex-row">
  {categories.map(cat => {
    const activated = catsFilter.findIndex(catId => catId === cat.id) !== -1;
    return <button key={cat.id} className={`menu-category ${activated?'is-activated':''}`} onClick={() => toggleCategory(cat.id)}>{cat[`name_${lang}`]}</button>
  })}
  <button className="menu-category max-w-max " onClick={() => setCatsFilter([])}><img src="assets/imgs/back.svg" alt="" className="sm:pl-2 sm:pr-2" /></button>

</nav>
  );
}
